// extracted by mini-css-extract-plugin
export default {"link":"go-back_link__wgFRf","arrowBack":"go-back_arrowBack__Ri24J"};